import script from "./WebinarIndex.vue?vue&type=script&setup=true&lang=js"
export * from "./WebinarIndex.vue?vue&type=script&setup=true&lang=js"

import "./WebinarIndex.vue?vue&type=style&index=0&id=e03c0b4e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e03c0b4e"]])

export default __exports__